import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { MdMoreHoriz } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { deleteKayitliAdres, setSelectedKayitliAdres } from "../../features/kayit/kayitSlice";
import { showModal } from "../../features/modal/modalSlice";
import AdminSurucuArayanlarContainer from "../adminContainers/adminIlanlar/AdminSurucuArayanlarContainer";
import { adminGetSurucuArayanlar } from "../../features/admin3/admin3Slice";
import InputSelectCity from "../shared/input/new/InputSelectCity";
import Btn from "../shared/button/Btn";
import Pagination from "../shared/Pagination";
import InputSelect from "../shared/input/new/InputSelect";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .titles {
      width: 100%;
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(10, 1fr); 
      padding-inline: 10px;
      align-items: center;
      gap: 15px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      text-align: center;
      color: ${({ theme }) => theme.mainTextColor};
    }
  }
`;

const titles = ["İlan Tarihi", "İl/İller", "Alınacak Sürücü Sayısı", "Maaş", "Diğer Yan Haklar", "Haftalık Tatili", "İlan Bitiş", "Onay","Durum","Sürücü Buldu Mu?"]

const durumData = [
  {
    id:1,
    text:"Yayında",
    bool: true
  },
  {
    id:2,
    text:"Arşivde",
    bool: false
  }
]

const onayData = [
  {
    id: 0,
    text: "Onay Bekliyor",
    bool: true
  },
  {
    id: 1,
    text: "Onaylandı",
    bool: true
  },
  {
    id: 2,
    text: "Reddedildi",
    bool: true
  }
]

const SurucuArayanlarAdmin = () => {
  const { theme } = useSelector((state) => state.layout);
  const { adminDriverSeekerList, adminDriverSeekerCount } = useSelector((state) => state.admin3);
  const dispatch = useDispatch()
  const [calisilacakIl, setCalisilacakIl] = useState("")
  const [ilanDurumu, setIlanDurumu] = useState(null)
  const [onayDurum, setOnayDurum] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(adminDriverSeekerCount / itemsPerPage);

  useEffect(() => {
    dispatch(adminGetSurucuArayanlar({workCity: calisilacakIl, page: currentPage, isApproved: onayDurum?.id, isActive: ilanDurumu?.bool}))
  }, [calisilacakIl, currentPage, onayDurum, ilanDurumu])

  const handleClear = () => {
    setCalisilacakIl("")
    setOnayDurum(null)
    setIlanDurumu(null)
  }

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="top-container">
            <InputSelectCity data={calisilacakIl?.value} setData={setCalisilacakIl} name={"calisilacakIl"} labelText={"Çalışılacak İl"} />
            <InputSelect data={ilanDurumu?.text} setData={setIlanDurumu} initialOptions={durumData} name={"ilanDurumu"} labelText={"İlan Durumu"} />
            <InputSelect data={onayDurum?.text} setData={setOnayDurum} initialOptions={onayData} name={"onayDurum"} labelText={"Onay Durumu"} />
            <Btn color="#E85446" bgColor="transparent" width={"150px"} handleClick={handleClear}>Temizle</Btn>
        </div>
        <div className="titles">
          {titles.map((item) => (
              <p>{item}</p>
          ))}
        </div>
        {adminDriverSeekerList.map((item) => (
          <AdminSurucuArayanlarContainer data={item} />
        ))}
        {(adminDriverSeekerList && adminDriverSeekerList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default SurucuArayanlarAdmin;
